
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"182.857","height":"182.857","viewBox":"0 0 48.381 48.381"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-51.842 -52.82)"}},[_c('path',{attrs:{"d":"M77.823 89.35c-.354-.182-4.952-4.798-5.077-5.1-.083-.2-.096-.804-.096-4.645v-4.416l-4.487-4.493c-4.971-4.976-4.716-4.677-4.529-5.303.105-.35.333-.621.628-.745.173-.072 2.044-.086 11.79-.086 8.054 0 11.636.02 11.758.066.526.2.839.92.636 1.464-.037.097-2.042 2.152-4.522 4.635l-4.457 4.46-.016 6.723c-.016 6.47-.021 6.73-.135 6.96-.253.51-.976.742-1.493.48z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"76.032","cy":"77.01","r":"21.99","fill":"none","stroke":"#fff","stroke-width":"4.4"}}),_c('path',{attrs:{"fill":"#fff","fill-rule":"evenodd","d":"M88.247 59.285l-20.604 37.55-3.826-2.099 20.604-37.55z"}})])])
          )
        }
      }
    